module.exports = __webpack_public_path__ + "static/media/sidebar-case-history.9ec7a46f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-case-history.svg
// module id = 793
// module chunks = 0